// extracted by mini-css-extract-plugin
export var card = "_5a-0";
export var content = "_5a-1";
export var contentLoading = "_5a-2";